import { createLifecycleFor } from 'actions/account/collections';

export const TYPE = 'checklistStatus';

export const { callApi, replace, reject, patterns } = createLifecycleFor(TYPE);

export const CONTENT_STATUS_DROPPED = '@content-status/dropped';
export const drop = () => ({ type: CONTENT_STATUS_DROPPED });
